import * as React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { useAppSelector } from "shared/libs/redux";
import { ConfirmProvider } from "material-ui-confirm";

export const withTheme = (Component: React.ComponentType) => () => {
  const state = useAppSelector((state) => state.theme);
  const theme = createTheme({
    typography: {
      fontFamily: ["Inter", "sans-serif"].join(","),
    },
    palette: {
      mode: state.mode,
      ...(state.mode === "light"
        ? {
            info: { main: "#D9D9D9" },
            primary: {
              main: "#7D7ED0",
            },
            green: { primary: "#7EAC4D" },
            background: {
              default: "#E7E9F1",
              paper: "#ffffff",
            },
            text: {
              primary: "#201D15",
              secondary: "#BFBFBF",
            },
          }
        : {
            background: {
              paper: "#272626",
            },
          }),
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <ConfirmProvider>
        <CssBaseline />
        <Component />
      </ConfirmProvider>
    </ThemeProvider>
  );
};
